import { render, staticRenderFns } from "./GrowthIndicators.vue?vue&type=template&id=956a78f4&scoped=true&"
import script from "./GrowthIndicators.vue?vue&type=script&lang=js&"
export * from "./GrowthIndicators.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/customerHome.css?vue&type=style&index=0&id=956a78f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956a78f4",
  null
  
)

export default component.exports